import { useContext } from 'react';

import { ConstructorContext } from '../context';

export const useConstructor = () => useContext(ConstructorContext);
